import dayjs from 'dayjs'

export const ReferralQueryKey = 'referral'
export const ReferralStorageKey = 'zkex_v3_referral'

export function getReferralCodeFromStorage(): string | null {
  return window.localStorage.getItem(ReferralStorageKey)
}
export function setReferralCodeToStorage(code: string): void {
  return window.localStorage.setItem(ReferralStorageKey, code)
}

export function isValidReferralCode(code: string): boolean {
  if (code === '' || code === undefined || code === 'null') return true
  return /^ZKEX[0-9]+$/.test(code)
}
export function getEarnsUseDate() {
  return dayjs().add(1, 'days').format('YYYY-MM-DD 00:00 To 23:59')
}

export function secondsUntilMidnight(): number {
  const now = dayjs()
  return now.utc().endOf('days').diff(now, 'second')
}

function padStartZero(val: string | number): string {
  return val.toString().padStart(2, '0')
}
export function convertSecondsToDHMS(seconds: number): {
  days: string
  hours: string
  minutes: string
  seconds: string
} {
  const days = padStartZero(Math.floor(seconds / (3600 * 24)))
  const hours = padStartZero(Math.floor((seconds % (3600 * 24)) / 3600))
  const minutes = padStartZero(Math.floor((seconds % 3600) / 60))
  const remainingSeconds = padStartZero(seconds % 60)

  return { days, hours, minutes, seconds: remainingSeconds }
}
